import {GeoJSON} from "ol/format";
import {fromCircle} from "ol/geom/Polygon";

export function getPrintLayerVector(layer) {

    const printLayer = {}
    printLayer.type = 'VectorV2'
    printLayer.sorting = 1000

    const features = []

    layer.getSource().getFeatures().map((feature, key) => {

        let featureItem = feature.clone()

        if(featureItem.getGeometry().getType() === 'Circle') {
            featureItem.setGeometry(fromCircle(feature.clone().getGeometry()))
        }

        featureItem.set('key', key)

        features.push(featureItem)
    })

    printLayer.geoJson = new GeoJSON().writeFeatures(features)

    return printLayer
}

export function getPrintLayerVectorByFeatures(features) {

    const printLayer = {}
    printLayer.type = 'VectorV2'
    printLayer.sorting = 1001

    printLayer.geoJson = new GeoJSON().writeFeatures(features)

    return printLayer
}
